import React from "react";
import { Layout } from "antd";
import OrganizerTNav from "./OrganizerTNav";

import { Outlet } from "react-router-dom";
const { Content } = Layout;
const OrganizerTLayout = ({ userId }) => {
  return (
    <Layout>
      <div className="profile-header">
        <div className="layout-width">
          <OrganizerTNav userId={userId} />
        </div>
      </div>
      <Content className="layout-width">
        <Outlet />
      </Content>
      {/* <Footer style={{ backgroundColor: "#2F89FC" }}>
        <HomeFooter />
      </Footer> */}
    </Layout>
  );
};
export default OrganizerTLayout;
